module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\n}\nvar additionalClasses = [];\nif(disabled)            additionalClasses.push('disabled');\nif(model.fullScreen)    additionalClasses.push('fullScreen');\nif(model.isDirty)       additionalClasses.push('isDirty');\nvar nrOfFiles = utils.collectionSize(model.dataJSON);\nvar preventFiles = (model.config || {}).showFiles === false && !model.fullScreen;\nvar fullScreenButtonType = 'fullScreen';\nif(model.fullScreen){\nfullScreenButtonType = 'closeFullScreen';\n}\n%>\n<div data-field-code=\"<%- model.fieldCode || '' %>\" class=\"<%= additionalClasses.join(' '); %>\">\n<div class=\"controls\">\n<%\nif(!preventFiles){\n%>\n<%- include('./file-button', { formMapping: formMapping, model: model, config: config }); %>\n<%\nif(model.extendedButtonActionsGranted){\n%>\n<%- include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-file', symbolOnly: !model.fullScreen } }); %>\n<%\n}\n%>\n<%- include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', symbolOnly: !model.fullScreen } }); %>\n<%\n}\n%>\n<%- include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-file', symbolOnly: !model.fullScreen } }); %>\n</div>\n<div class=\"notices\">\n<div class=\"notice dirty\"><%= __('hint.fileField.dirty') %></div>\n<%\nif(nrOfFiles <= 0) {\n%><div class=\"notice\"><%= __('hint.fileField.empty') %></div><%\n} else if(preventFiles) {\n%><div class=\"notice\"><%= __('hint.fileField.hiddenFiles', { nrOfElements: nrOfFiles }) %></div><%\n}\n%>\n</div>\n<div class=\"mediaContainer\">\n<div class=\"media\">\n<%\nif(nrOfFiles > 0 && !preventFiles) {\nutils.forEach(model.dataJSON, function(file){\n%>\n<%- include('../media/file/file', { resourceData: file, config: { context: 'assignment' }, formMapping: formMapping }); %>\n<%\n});\n}\n%>\n</div>\n</div>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\file.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
}
var additionalClasses = [];
if(disabled)            additionalClasses.push('disabled');
if(model.fullScreen)    additionalClasses.push('fullScreen');
if(model.isDirty)       additionalClasses.push('isDirty');
var nrOfFiles = utils.collectionSize(model.dataJSON);
var preventFiles = (model.config || {}).showFiles === false && !model.fullScreen;
var fullScreenButtonType = 'fullScreen';
if(model.fullScreen){
fullScreenButtonType = 'closeFullScreen';
}

    ; __line = 16
    ; __append("\n<div data-field-code=\"")
    ; __line = 17
    ; __append( model.fieldCode || '' )
    ; __append("\" class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<div class=\"controls\">\n")
    ; __line = 19
    ; 
if(!preventFiles){

    ; __line = 21
    ; __append("\n")
    ; __line = 22
    ; __append( include('./file-button', { formMapping: formMapping, model: model, config: config }) )
    ; __append("\n")
    ; __line = 23
    ; 
if(model.extendedButtonActionsGranted){

    ; __line = 25
    ; __append("\n")
    ; __line = 26
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-file', symbolOnly: !model.fullScreen } }) )
    ; __append("\n")
    ; __line = 27
    ; 
}

    ; __line = 29
    ; __append("\n")
    ; __line = 30
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', symbolOnly: !model.fullScreen } }) )
    ; __append("\n")
    ; __line = 31
    ; 
}

    ; __line = 33
    ; __append("\n")
    ; __line = 34
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-file', symbolOnly: !model.fullScreen } }) )
    ; __append("\n</div>\n<div class=\"notices\">\n<div class=\"notice dirty\">")
    ; __line = 37
    ; __append(escapeFn( __('hint.fileField.dirty') ))
    ; __append("</div>\n")
    ; __line = 38
    ; 
if(nrOfFiles <= 0) {

    ; __line = 40
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( __('hint.fileField.empty') ))
    ; __append("</div>")
    ; 
} else if(preventFiles) {

    ; __line = 42
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( __('hint.fileField.hiddenFiles', { nrOfElements: nrOfFiles }) ))
    ; __append("</div>")
    ; 
}

    ; __line = 44
    ; __append("\n</div>\n<div class=\"mediaContainer\">\n<div class=\"media\">\n")
    ; __line = 48
    ; 
if(nrOfFiles > 0 && !preventFiles) {
utils.forEach(model.dataJSON, function(file){

    ; __line = 51
    ; __append("\n")
    ; __line = 52
    ; __append( include('../media/file/file', { resourceData: file, config: { context: 'assignment' }, formMapping: formMapping }) )
    ; __append("\n")
    ; __line = 53
    ; 
});
}

    ; __line = 56
    ; __append("\n</div>\n</div>\n</div>")
    ; __line = 59
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\file.ejs

}